import styled from 'styled-components';
import { RiSearchLine } from 'react-icons/ri';
import { colors } from '@/constants'; // Ajuste o caminho se necessário

import {
  RiCheckboxCircleFill,
  RiCheckboxBlankCircleLine,
} from "react-icons/ri";

export const ButtonSpan = styled.span``;

export const CheboxContent = styled.div<{ $isdisabled: boolean }>`
  opacity: ${(i) => (i.$isdisabled ? 0.2 : 1)};
`;

export const CheckboxCircle = styled(RiCheckboxCircleFill)`
  color: ${colors.alert.green300};
`;

export const CheckboxBlankCircle = styled(RiCheckboxBlankCircleLine)`
  color: ${colors.gray.gray40};
`;

export const CoordinatorInfo = styled.div`
  border-bottom: 1px solid ${colors.gray.gray10};
  color: ${colors.brand.grafite};
  padding-bottom: 20px;

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 14.06px;
    
  }

  span {
    font-size: 12px;
    color: ${colors.gray.gray40};
  }

  strong{
    font-size: 16px;
    font-weight: 500;
    line-height: 25.6px;
  }
`;

export const RCACard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;

  border-radius: 8px;
  background-color: ${colors.brand.white};
  box-shadow: 0px 1px 4px ${colors.shadown1};
  padding: 12px 16px;
`;

export const RCATopInfo = styled.div`
  margin-bottom: 8px;
`;

export const RCAName = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.gray.gray60};
`;

export const RCADescription = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 14.06px;

  color: ${colors.gray.gray60};

  background-color: ${colors.gray.gray10};
  padding: 4px 8px;
  border-radius: 4px;
`;

export const RCABottomInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  justify-content: space-between;
`;

export const RCAMeta = styled.div`
  font-size: 12px;
  color: ${colors.gray.gray50};
  margin-right: 10px;

  strong {
    font-weight: 600;
    color: ${colors.gray.gray60};
  }
`;

export const RCAReal = styled.div`
  font-size: 12px;
  color: ${colors.gray.gray50};

  strong {
    font-weight: 600;
    color: ${colors.gray.gray60};
  }
`;

export const RCALinkDetails = styled.button`
  border: none;
  background: transparent;
  font-size: 12px;
  color: ${colors.brand.red};
  text-decoration: underline;
  cursor: pointer;
  margin-left: auto;
`;

export const BottomText = styled.p`
  margin-top: 10px;
  font-size: 12px;
  color: ${colors.gray.gray50};
  text-align: center;
`;

// Reutilizando estilos já existentes para InputContent, SearchIcon, InputModal, ModalTitle, BottomContent, ButtonAccess, etc.

export const InputContent = styled.div`
  gap: 14px;
  width: 100%;
  padding: 20px;
  position: relative;
  z-index: 10;
  align-items: center;
  display: inline-flex;
  background-color: ${colors.brand.white};
  border-bottom: 1px solid ${colors.background1};
`;

export const SearchIcon = styled(RiSearchLine) <{ $isgray?: boolean }>`
  color: ${(i) => (i.$isgray ? colors.gray.gray40 : colors.brand.white)};
`;

export const InputModal = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 700;
  &::placeholder {
    font-weight: 400;
    color: ${colors.gray.gray40};
  }
`;

export const ModalTitle = styled.h6`
  top: 0px;
  z-index: 1;
  height: 70px;
  display: grid;
  font-size: 16px;
  z-index: 11;
  font-weight: 500;
  position: sticky;
  place-items: center;
  color: ${colors.gray.gray60};
  background-color: ${colors.brand.white};
  border-bottom: 1px solid ${colors.gray.gray10};
`;

export const BottomContent = styled.div`
  bottom: 0px;
  width: 100%;
  position: fixed;
  background-color: #fff;
  padding: 20px 16px;
  border-top: 1px solid #e9e8e7;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0px -6px 20px 0px #00000026;
`;

export const ButtonAccess = styled.button<{ disabled: boolean }>`
  width: 100%;
  border: none;
  padding: 18px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  color: ${colors.brand.white};
  background-color: ${colors.green};
  opacity: ${(i) => (i.disabled ? 0.75 : 1)};
`;

export const ContentListCompany = styled.div`
  padding-bottom: 200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 100%;
  background-color: ${colors.gray.gray10};
`;